import { withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";
import Typography from "@material-ui/core/Typography";
import { useHistory } from "react-router-dom";
import { Variant as ThemeVariant } from "@material-ui/core/styles/createTypography";
import { styles } from "./BlueLink.styles";

interface IBlueLinkProps extends WithStyles<typeof styles> {
    variant: ThemeVariant;
    to?: string;
    children?: React.ReactNode;
    className?: any;
    inline?: boolean;
    onClick?: any;
}

const BlueLinkPure: React.FunctionComponent<IBlueLinkProps> = ({variant, to, children, className, inline, onClick, classes}: IBlueLinkProps) => {
    const history = useHistory();

    return (
        <Typography display={inline ? "inline" : "initial"} onClick={onClick ? onClick : () => history.push(to)} variant={variant} className={`${classes.link} ${className}`}>
            {children}
        </Typography>
    );
};

export const BlueLink = withStyles(styles)(BlueLinkPure);
